import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { environment } from '../../../environments/environment';
import { isPlatformBrowser } from '@angular/common';
import { CookieConsentService } from './../utils/cookie/cookie-consent.service';

declare var fbq: any;

@Injectable()
export class FbqService {
  constructor(
    private router: Router,
    private cookieConsentService: CookieConsentService,
    @Inject(PLATFORM_ID) private platformId: object,
    @Inject('WINDOW') private window: any
  ) {
    this.init();
  }

  init(): boolean {
    if (this.window && isPlatformBrowser(this.platformId)) {
      if (environment.facebook_pixel_id) {
        if (typeof fbq === 'undefined') {
          throw new Error('Facebook Pixel is not loaded.')
        }

        this.cookieConsentService.emitter.subscribe(consent => {
          if (consent === false)
            this.disableTracking();
          else
            this.enableTracking();
        });

        if (this.cookieConsentService.getConsent() === false)
          this.disableTracking();

        fbq('init', environment.facebook_pixel_id);

        this.router.events.subscribe(event => {
          if (event instanceof NavigationEnd) {
            fbq('track', 'PageView');
          }
        });

        return true;
      }
    }

    return false;
  }

  // fbq('track', 'eventName', {customData});
  sendEvent(fbqEvent: string, customData: {}): boolean {
    if (!environment.facebook_pixel_id)
      return false;

    if (typeof fbq === 'undefined') {
      throw new Error('Facebook Pixel is not loaded.')
    }

    if (isPlatformBrowser(this.platformId))
      fbq('track', fbqEvent, customData);
    else
      return false;

    return true;
  }

  disableTracking(): void {
    fbq('consent', 'revoke');
  }

  enableTracking(): void {
    fbq('consent', 'grant');
  }
}



// WEBPACK FOOTER //
// ./src/app/common-theme/analytics/fbq.service.ts